import "./styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import Header from "./Header";
import Emptiness from "../../components/UI/emptiness/Emptiness";
import Spinner from "../../components/UI/spinner/Spinner";
import Filter from "../../components/filters/Filter"; 
import Timofey from "../../assets/images/Timofey_avatar.png";
import NewsItem from "./NewsItem";
import { Context } from "../..";
import useFilters from "../../customHooks/useFilters";
import { INews, INewsRes } from "../../models/INews";
import { IPagination } from "../articles";
import Pagination from "../../components/pagination/Pagination";
import { scrollToTop } from "../../utils";

const News: FC = () => {
  const { news, store, roles } = useContext(Context);
  const [page, setPage] = useState(1);
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const [pagination, setPagination] = useState<IPagination>({
    allCount: 0,
    countPages: 0,
  });
  const statusFilter = useFilters();
  // const statesFilter = useFilters();

  const [allNews, setAllNews] = useState<INews[]>([]);

  const newsContainer = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    news.setNewsFilter(
      statusFilter.checkedValues
      );
    news
      .loadList(page)
      .then((res: INewsRes) => {
        scrollToTop(newsContainer);
        setAllNews(res.result);
        setPagination(res.pagination);
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter.checkedValues, news, page]);
  
  useEffect(() => {
    setAllNews(news.NewsList);
  }, [news.NewsList]);

  const searchItems = (searchValue: string) => {
    if (searchValue !== "") {
      const filteredData = news.NewsList.filter((item: any) => {
        const { content: _, ...rest } = item
        return Object.values(rest)
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setAllNews(filteredData);
    } else {
      setAllNews(news.NewsList);
    }
  };

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "marketing")?.children?.find((child: any) => child.path === "news")
    setAdminPermissionData(userData)
  };

  useEffect(() => {
    loadNewData()
  }, [])

  return (
    <div className="news">
      <Header page={page} searchItems={searchItems} actionData={adminPermissionData}/>
      <div ref={newsContainer} className="body">
        {allNews.length > 0 && !news.loadingNewsBool ? (
          allNews.map((item, index) => (
            <NewsItem page={page} item={item} key={item._id} actionData={adminPermissionData}/>
          ))
        ) : allNews.length === 0 && !news.loadingNewsBool ? (
          <Emptiness icon={Timofey} content="It's time to create some news!" />
        ) : (
          <Spinner />
        )}
      </div>
      <div className="filters">
        <Filter
          title="Status"
          list={[
            { label: "Active", default: true, value: "show" },
            { label: "Archive", default: false, value: "hidden" },
            { label: "Delete", default: false, value: "deleted" },
          ]}
          onSelect={statusFilter.handleSelect}
        />
        {/* <Filter
          title="Show"
          list={[
            { label: "All", default: true, value: "All" },
            { label: "NSW", default: false, value: "nsw" },
            { label: "VIC", default: false, value: "vic" },
            { label: "QLD", default: false, value: "qld" },
            { label: "SA", default: false, value: "sa" },
            { label: "TAS", default: false, value: "tas" },
            { label: "NT", default: false, value: "nt" },
            { label: "ACT", default: false, value: "act" },
            { label: "WA", default: false, value: "wa" },
          ]}
          onSelect={statesFilter.handleSelect}
        /> */}
      </div>
      <Pagination
        totalItems={pagination.allCount}
        itemsPerPage={12}
        currentPage={page}
        onPageChange={setPage}
      />
    </div>
  );
};

export default observer(News);
